
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Link from './../../zviz2/zviz/components/link';
import config from './../../config';
import {styleWords, styleText} from './../../styles';
import {extend} from './../../zviz2/zviz/functions';

import BlueprintListItem from './item';
import BlueprintHeader from './header';
import BlueprintLoader from './../elements/loader';

import detailsModel from './../../model/details';
import Xhr from '../../zviz2/zviz/xhr.js';
import {ExcelExport} from '../../helpers/excel-export.js';


let loadMoreAmount = 10;
const columnStyles = {
    'creation_date': 'date',
    'planned_completion_date': 'date',
    'planned_start_date': 'date',
    'completion_date': 'date',
    'rec_date': 'date'
};

const columnWidths = {
    'eval_id': 15,
    'eval_number': 15,
    'eval_title': 60,
    'tech_unit_id': 15,
    'eval_rpt_end_year': 15,
    'll_desc': 60,
    'll_challenges': 60,
    'll_context': 60,
    'll_success': 60,
    'll_comments': 60,
    'gp_desc': 60,
    'gp_context': 60,
    'gp_cause': 60,
    'rec_desc': 60,
    'rec_action_plan': 60,
    'rec_comments': 60,
    'rec_response': 60,
    'rec_info_source': 60,
    'url':60
};

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
        this.initialLimit = 10;
        this.limit = this.initialLimit;
        this.defaultOrder = {field: this.models['details'].getCountField(), direction: 1};
        this.order = this.defaultOrder;
        this.currentSource = state.get('source');
        
        this.exportLabels = {};

    }

    changeOrder(){
        this.order = state.get('order') || this.defaultOrder;
        this.models['details'].sortItems(this.order.field, this.order.direction);
        this.update();
    }

    init(renderer){
        super.init(renderer);

    }

    loadData(){
        this.isLoading = false;
        if(this.models['details'].status == 'success'){
            let data = this.models['details'].data;
            if(! data['details']){
                state.set('list.details_id', null);
                // this.limit = this.initialLimit;
                // state.set('list.limit', this.limit);
            }
            if(this.currentSource != state.get('source')){
                this.currentSource = state.get('source');
                this.order = {field: this.models['details'].getCountField(), direction: 1};
            }
            this.models['details'].sortItems(this.order.field, this.order.direction);

            if(this.models['details'].items.length === 1 && ! state.get('list.details_id')){
                state.set('list.details_id', this.models['details'].items[0].eval_id);
            }
            // this.update();
        }else if(this.models['details'].status == 'loading'){
            this.isLoading = true;
            // this.update();
        }else if(this.models['details'].status == 'failed'){
            this.isLoading = false;
            state.set('errorMessage', {title: 'Error loading data', description: this.models['details'].error || ''} );
            // this.update();
        }
    }

    getTotals(){
        this.loadData();
        let source = state.get('source');
        let sourceName = config.data.sourceTitles[source];
        return this.models['details'].items.length + ' matching ' + sourceName;
    }

    exportData(project=false){
        let params = {};

        let filter = state.get('filter');
        if(! filter[this.models['details'].getCountField()]){
            filter[this.models['details'].getCountField()] = '__NOT_EMPTY__';
        }
        filter['planned_flag'] = true; // set the right value in processFilter
        if(filter.year){
            filter['eval_rpt_end_year'] = filter.year.slice(0);
            delete filter.year;
        }
        const search = state.get('filter.search')
        if(search){
            params.search = search;
        }
        params.filter = this.models['details'].processFilter(filter);

        let cols = this.models['details'].getColumns(true, true);
        // These columns below are of type CLOB and cannot be selected when grouping results. For now we are
        // leaving them out of the export.
        cols = cols.filter((col) => (
            ! ['ll_context', 'll_success', 'll_challenges', 'll_admin_issues', 'll_comments'].includes(col[0])
        ));
        const colMapping = cols.map((c) => {
            return {
                key: c[0],
                label: this.getLabel(c[0], false)
            };
        });
        // add url for (planned) evaluation exports
        const source = state.get('source');
        const includeUrl = source === 'planned' || source === 'eval';
        if(includeUrl){
            // adding the year to compile the url to the planned evaluation correctly (year isn't shown in
            // the export at the moment)
            cols.push(['eval_rpt_end_year']);
        }
        params.select = this.formatSelects(cols).join(',');

        let field = this.models['details'].getCountField();
        params.orderBy = field + ' asc';

        const options = {
            method: 'GET',
            useXMLHttpRequest: true,
            data: params
        };
        // returns an Excel serial date number
        const parseDate = (input) => {
            const d = input.split(' ')[0].replace(/\//g, '-');
            const date = new Date(d);
            // we ignore the timezone shift
            const converted = 25569.0 + 
                    ((date.getTime() /*- (date.getTimezoneOffset() * 60 * 1000) */) / (1000 * 60 * 60 * 24));
            return Math.round(converted); // trucate the time component
        };

        const createUrl = (evaluation) => {
            const url = window.location.origin + config.evaluationContext + '#eval_id=' + evaluation.eval_id;
            // for planned evaluations, select the right tab and set the year correctly. Otherwise the
            // evaluation will not show up.
            if(source === 'planned'){
                return url + '&source=planned&year=' + evaluation.eval_rpt_end_year;
            }
            return url;
        }

        const onDataReceived = (response) => {
            const result = JSON.parse(response);            
            if(! result.success){
                onError('Failed to load data. ' + result.error);
                return false;
            }

            if(! result.value || result.value.length === 0){
                onError('No data');
                return;
            }
            const columns = colMapping.map((col) => {
                return {
                    title: col.label,
                    id: col.key,
                    width: columnWidths[col.key] || 40,
                    style: columnStyles[col.key] || 'default'
                };
            });
            columns.push({
                title: 'Url',
                id: 'url',
                width: columnWidths['url'] || 40,
                style: columnStyles['url'] || 'default'
            });

            const data = result.value.map((row) => {
                const newRow = Object.keys(row).reduce((obj, key) => {
                    obj[key] = row[key] instanceof Array ? 
                            row[key].map((v) => (v === '__EMPTY__' ? '-' : v)).join('; ') : 
                            (columnStyles[key] === 'date' ?
                                    parseDate(row[key]) : 
                                    (row[key] === '__EMPTY__' ? '-' : row[key]));
                    return obj;
                }, {});
                newRow.url = createUrl(newRow);
                return newRow;
            });
            const excelExp = new ExcelExport();
            excelExp.addDataSheet(data, columns, 'Data')
            excelExp.download();

        };
        const onError = (error) => {
            alert('Failed to export data ' + error);
        };
        const xhr = new Xhr(config.root + 'select', options, onDataReceived, onError);
        xhr.start();

    }

    getExportLabels(fields){
        let result = [];
        for(let i = 0; i < fields.length; i++){
            result.push(config.data.dimensionTitles[fields[i][0]] || fields[i][0]);
        }
        return result;
    }

    formatSelects(fields){
        let result = [];
        for(let i = 0; i < fields.length; i++){
            let sel = fields[i][0];
            if(sel == this.models['details'].getCountField() || sel == 'eval_id'){
                result.push(sel);
            }else{
                if(fields[i][1] && fields[i][1]=='concat_distinct'){
                    sel = 'collection('+sel+')';
                }
                result.push(sel + ' as ' + fields[i][0]);
            }
        }
        return result;
    }
    
    getLabel(field, clean=true){
        let title = config.data.dimensionTitles[field] || field;
        if(field in this.exportLabels){
            title = this.exportLabels[field];
        }
        if(clean){
            return title.replace(/ /g, '_').replace(/\(/g, '[').replace(/\)/g, ']');
        }else{
            return title;
        }
    }

    getChildren(){
        this.loadData();
        let result = [];

        if(this.isLoading){
            return [];
        }

        let limit = state.get('list.limit') || this.initialLimit;
        this.limit = limit;

        let columns = this.models['details'].getColumns();
        let cf = this.models['details'].getCountField();

        let detailsId = state.get('list.details_id');

        result.push(extend({
            uid: '_liHeader',
            properties: {
                data: {
                    columns: columns,
                }
            }
        }, BlueprintHeader));
        
        for(let i = 0; i < this.models['details'].items.length; i++){
            if(i >= limit){
                break;
            }
            let item = this.models['details'].items[i];
            
            let details = false;
            if(detailsId && item[cf] && item[cf] == detailsId){
                details = this.models['details'].details;
            }

            result.push(extend({
                // uid: '_li' + item[cf],
                properties: {
                    data: extend({
                        index: i,
                        columns: columns,
                        details: details
                    }, item)
                }
            }, BlueprintListItem));
        }

        if(limit < this.models['details'].items.length){
            result.push(extend({
                properties: { 
                    data: { more: Math.min(loadMoreAmount, this.models['details'].items.length - limit) }
                }
            }, BlueprintMore));
        }

        // if(this.models['details'].details){
        //     if(this.models['details'].details[cf]){
        //         // state.set('list.details_id', this.models['details'].details[cf]);
        //     } 
        // }

        return result;

    }

    remove(renderer, removeFromParent=true){
        super.remove(renderer, removeFromParent);
        state.set('list', null);
    }

} 



let Blueprint = extend({
    type: Controller,
    models: {
        'details': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['details'], [ctrl, ctrl.update]) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'list.limit', ctrl.initialLimit) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.changeOrder], 'order', {field: ctrl.models['details'].getCountField(), direction: 1}) )
    ],
    properties: {
        style: { position: 'relative' }
    },
    children: [ 
        extend({
            properties: {
                style: {
                    width: '50%',
                    padding: (ctrl) => ( (state.get('renderSize') == 'small')? '0px 10px': '0px 0px'),
                    display: 'inline-block',
                    textAlign: 'right',
                    float: 'right'
                },
            },
            children: [
                extend({
                    properties: {
                        style: extend({
                            display: 'block',
                            fontSize: '9pt',
                            padding: '15px 0px 10px'
                        }, styleText),
                        content: 'By using the export button you can download all details about the evalution document from the current selection to a CSV-file.'
                    }
                }, TextBox),

                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            color: 'white',
                            textTransform: 'uppercase',
                            background: '#1E2DBE url(\'' + config.imgPath + 'export.png\') 7px center no-repeat',
                            padding: '0px 7px 0px 35px',
                            height: '28px',
                            lineHeight: '28px',
                            fontSize: '10pt'
                        }, styleWords),
                        content: 'Export'
                    },
                    events: {
                        click: (event, ctrl) => { ctrl.parent.parent.exportData(); }
                    }
                }, Link)
            ]
        }, Group),
        
        (parent) => (extend({
            properties: {
                style: extend({
                    width: '40%',
                    padding: (ctrl) => ( (state.get('renderSize') == 'small')? '30px 0px 50px 10px': '30px 0px 50px'),
                    display: 'inline-block'
                }, styleWords),
                content: parent.getTotals()
            }
        }, Group) ),

        (ctrl) => ( ctrl.getChildren() ),

        (ctrl) => ( ctrl.models['details'].status!='success'? extend({properties: {data: { top: '250px' }}}, BlueprintLoader): [] )
     ]
}, Group);

let BlueprintMore = extend({
    properties: {
        style: extend({
            display: 'block',
            textAlign: 'center',
            paddingTop: '50px',
            background: 'transparent url(\'' + config.imgPath + 'show_more_list.png\') center 10px no-repeat',
            color: '#1E2DBE',
            textStyle: 'italic'
        }, styleText),
        data: { more: loadMoreAmount },
        content: (ctrl) => ( 'Show ' + ctrl.data.more + ' more items' )
    },
    events: {
        click: (event, ctrl) => { state.set('list.limit', ctrl.parent.limit+10); }
    }
}, Link);




export default Blueprint;
export {Controller, Blueprint};

